module.exports = __webpack_public_path__ + "static/Data Structuring 2-87b2ecf7f61c74b0d00c53aa813ae8af.png";